var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"meeting-item",nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('div',{staticClass:"flex"},[_c('div',[_vm._v(_vm._s(_vm.data.name)+" -")]),_c('div',[_vm._v(_vm._s(_vm._f("dateFormatName")(_vm.data.startTime)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }